import _ from 'lodash';
import React from 'react';
import Api from '../gd/api/api';

class CompanyModalsManager {

    constructor() {}

    newDepartment(companyId, callback) {
        gd.modal.showForm({
            header: {
                title: 'New Department',
            },
            component: require('./company/add-department/add-department'),
            params: {
                onSubmit: function(value) {

                    const res = Api.Company.addDepartment(companyId, value.name);

                    res.done(data=>{
                        gd.modal.hide();
                        if (callback) callback();
                    });

                    res.fail(error=>{
                        console.error("insert error",error);
                        gd.modal.hide();
                    });

                }.bind(this),
                autofocus: true
            }
        });
    }

}

module.exports = CompanyModalsManager;